import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getKycOcrApi, patchKycDLOcrApi, patchKycOcrApi, patchKycPanOcrApi, postKycOcrApi, getKycPanOcrApi } from "../helpers/KycHelperApi";


const initialState =
{
    updatedOcrdata: {},
    verifiedGetData: {},
    getPanData: {},
    digilockerDataCode: {
        digilockerid: "",
        reference_key: ""
    }
};
export const patchKycOcrReducer = createAsyncThunk('/updateOcrinformation', async (data, thunkAPI) => {

    try {
        const response = await patchKycOcrApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const postKycOcrApiReducer = createAsyncThunk('/postkycverifyed', async (data, thunkAPI) => {
    try {
        const response = await postKycOcrApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const getKycOcrApiReducer = createAsyncThunk('/getKycdata', async (_, thunkAPI) => {
    try {
        const response = await getKycOcrApi();
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);

    }
});

export const patchKycPanOcrApiReducer = createAsyncThunk('/updatepanOcrinformation', async (data, thunkAPI) => {
    try {
        const response = await patchKycPanOcrApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


export const getKycPanOcrApiReducer = createAsyncThunk('/getpanOcrinformation', async (_, thunkAPI) => {
    try {
        const response = await getKycPanOcrApi()
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});

export const patchKycDLOcrApiReducer = createAsyncThunk('/updateDLocrinformation', async (data, thunkAPI) => {
    try {
        const response = await patchKycDLOcrApi(data);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.message);
    }
});


const KYCSlice = createSlice({
    name: 'KYC',
    initialState, //  Correct key
    reducers: {
        clearPrivateIDState: (state) => {
            state.verifiedGetData = {}
            // state.error = null;
        },

        // Add reducer to update digilocker data
        setDigilockerData: (state, action) => {
            state.digilockerDataCode = {
                ...state.digilockerDataCode,
                ...action.payload
            };
        },

        // Optional: Clear digilocker data
        clearDigilockerData: (state) => {
            state.digilockerDataCode = {
                digilockerid: "",
                reference_key: ""
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(patchKycOcrReducer.fulfilled, (state, action) => {
                state.updatedOcrdata = action.payload;
            })
            .addCase(patchKycOcrReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getKycPanOcrApiReducer.fulfilled, (state, action) => {
                state.getPanData = action.payload;
            })
            .addCase(getKycPanOcrApiReducer.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(getKycOcrApiReducer.fulfilled, (state, action) => {
                // console.log("GET KYC OCR DATA", action.payload);
                state.verifiedGetData = action.payload;
            })
            .addCase(getKycOcrApiReducer.rejected, (state, action) => {
                state.error = action.error.message;
            });
    }
});


export const { clearPrivateIDState, setDigilockerData, clearDigilockerData } = KYCSlice.actions;
export default KYCSlice.reducer;